const mainStyle = (props) => {
    let arrow = props.arrow;
    let paging = props.paging;
    let s = props.sliderProps;
    // console.log(x); "blur","bgOpacity",
    let slider = { autoWidth: false, width: 0 }
    if (s.responsiveBehavior === "item") {
        slider = { autoWidth: true, width: s.itemWidth }
    }
    let style = document.createElement('style');
    let pd_bottom = 0;

    style.innerHTML = `
        /*splide*/
        .splide__container{box-sizing:border-box;position:relative}.splide__list{backface-visibility:hidden;display:-ms-flexbox;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{/*display:none*/}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{backface-visibility:hidden;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__arrow{-ms-flex-align:center;align-items:center;background:#ccc;border:0;border-radius:50%;cursor:pointer;display:-ms-flexbox;display:flex;height:2em;-ms-flex-pack:center;justify-content:center;opacity:.7;padding:0;position:absolute;top:${s.pagination === 'none'?"50%":"calc(50% - 12px)"};transform:translateY(-50%);width:2em;z-index:1}.splide__arrow svg{fill:#000;height:1.2em;width:1.2em}.splide__arrow:hover:not(:disabled){opacity:.9}.splide__arrow:disabled{opacity:.3}.splide__arrow:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide__arrow--prev{left:1em}.splide__arrow--prev svg{transform:scaleX(-1)}.splide__arrow--next{right:0.5em}.splide.is-focus-in .splide__arrow:focus{outline:3px solid #0bf;outline-offset:3px}.splide__pagination{left:0;padding:0 1em;right:0;z-index:1}.splide__pagination__page{background:#ccc;border:0;border-radius:50%;display:inline-block;height:8px;margin:3px;opacity:.7;padding:0;position:relative;transition:transform .2s linear;width:8px}.splide__pagination__page.is-active{background:#fff;transform:scale(1.4);z-index:1}.splide__pagination__page:hover{cursor:pointer;opacity:.9}.splide__pagination__page:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__pagination__page:focus{outline:3px solid #0bf;outline-offset:3px}.splide__progress__bar{background:#ccc;height:3px}.splide__slide{-webkit-tap-highlight-color:rgba(0,0,0,0)}.splide__slide:focus{outline:0}@supports(outline-offset:-3px){.splide__slide:focus-visible{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide__slide:focus-visible{border:3px solid #0bf}}@supports(outline-offset:-3px){.splide.is-focus-in .splide__slide:focus{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide.is-focus-in .splide__slide:focus{border:3px solid #0bf}.splide.is-focus-in .splide__track>.splide__list>.splide__slide:focus{border-color:#0bf}}.splide__toggle{cursor:pointer}.splide__toggle:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__toggle:focus{outline:3px solid #0bf;outline-offset:3px}.splide__track--nav>.splide__list>.splide__slide{border:3px solid transparent;cursor:pointer}.splide__track--nav>.splide__list>.splide__slide.is-active{border:3px solid #000}.splide__arrows--rtl .splide__arrow--prev{left:auto;right:0.5em}.splide__arrows--rtl .splide__arrow--prev svg{transform:scaleX(1)}.splide__arrows--rtl .splide__arrow--next{left:1em;right:auto}.splide__arrows--rtl .splide__arrow--next svg{transform:scaleX(-1)}.splide__arrows--ttb .splide__arrow{left:50%;transform:translate(-50%)}.splide__arrows--ttb .splide__arrow--prev{top:1em}.splide__arrows--ttb .splide__arrow--prev svg{transform:rotate(-90deg)}.splide__arrows--ttb .splide__arrow--next{bottom:1em;top:auto}.splide__arrows--ttb .splide__arrow--next svg{transform:rotate(90deg)}.splide__pagination--ttb{bottom:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;left:auto;padding:1em 0;right:.5em;top:0}
        .splide__slide--has-video{cursor:pointer}.splide__slide--has-video:hover .splide__video__play{opacity:1}.splide__slide__container--has-video{cursor:pointer;position:relative}.splide__slide__container--has-video:hover .splide__video__play{opacity:1}.splide__video{height:100%;left:0;position:absolute;top:0;width:100%}.splide__video__wrapper{background:#000;height:inherit;width:inherit}.splide__video__wrapper div,.splide__video__wrapper iframe,.splide__video__wrapper video{height:100%;width:100%}.splide__video__play{align-items:center;background:#ccc;border:0;border-radius:50%;cursor:pointer;display:flex;height:40px;justify-content:center;left:50%;opacity:.7;position:absolute;top:50%;transform:translate(-50%,-50%);transition:opacity .1s linear;width:40px}.splide__video__play:after{border-color:transparent transparent transparent #000;border-style:solid;border-width:9px 0 9px 17px;content:"";display:inline-block;margin-left:4px};
        /*splide modificators*/
        .splide__track{
            overflow: visible;
        }
        .splide__slide {
            height: max-content;
        }
        .splide{
            display: flex;
            flex-direction: column;
        }
        .splide__arrows {
            display:${s.displayNav?"inherit":"none"};
        }
        .splide__arrow{
            background-color: ${arrow.backgroundColor};
            opacity: ${arrow.opacity/100};
            width: ${arrow.width}px;
            height: ${arrow.height}px;
            border-radius: ${arrow.borderRadius}px;
        }
        .splide__arrow:hover:not(:disabled){
            background-color: ${arrow.hoverBackgroundColor};
            opacity: ${arrow.hoverOpacity/100};
        }
        .splide__arrow svg{
            fill: ${arrow.iconColor};
            height: auto;
            width: ${arrow.iconWidth}%;
        }
        .splide__pagination{
            display:${s.pagination === "dots"?"flex":"none"};
            position: relative !important;
            padding-top: 10px;
        }
        .splide__track{
            margin-left: ${s.padding}px !important;
            margin-right: ${s.padding}px !important;
        }
        .splide__pagination__page {
            background-color:${paging.backgroundColor};
            opacity: ${paging.opacity/100};
            width: ${paging.width}px;
            height: ${paging.height}px;
            border-radius: ${paging.borderRadius}px;
        }
        .splide__pagination__page.is-active {
            background-color:${paging.activeBackgroundColor};
            opacity: ${paging.activeOpacity/100};
            transform: scale(${paging.activeScale}%);
        }
        .splide__pagination__page:hover {
            background-color:${paging.hoverBackgroundColor};
            opacity: ${paging.hoverOpacity/100};
        }
        .splide__list, .splide__slide, .splide, .splide__track{
            height: 100% !important;
        }
        .splide__slide{
            overflow: hidden;
            border-radius: ${s.borderRadius}px;
            ${slider.autoWidth?'width:'+slider.width+"px":''}
        }
        .splide__slide img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
        .splide__slide img {
            transition: transform .3s ease-in-out, filter .3s ease-in-out;
            -webkit-transition: -webkit-transform .3s ease-in-out, -webkit-filter .3s ease-in-out; /* For Safari compatibility */
            ${s.hoverEffect.startsWith("from-")?s.hoverEffect.split("-")[2]:""};
        }
        .splide__slide:hover img {
            transition: transform .3s ease-in-out, filter .3s ease-in-out;
            -webkit-transition: -webkit-transform .3s ease-in-out, -webkit-filter .3s ease-in-out; /* For Safari compatibility */
            ${s.hoverEffect.startsWith("from-")?s.hoverEffect.split("-")[1]:s.hoverEffect};
        }
        .my-carousel-progress {
          background: #ccc;
          margin-top: 14px;
          margin-left: ${s.padding}px !important;
          margin-right: ${s.padding}px !important;
          margin-bottom: 3px;
        }
        .my-carousel-progress-bar {
          background: #FF0000;
          height: 2px;
          transition: width 400ms ease;
          width: 0;
        }
        .splide__video__play, .splide__arrow, .splide__pagination__page {
            border-radius: ${s.buttonsBorder}% !important;
        }
        .splide__arrow, .splide__video__play, .my-carousel-progress {
            background-color: ${s.bgColor} !important;
        }
        .splide__arrow:hover:not(:disabled) {
            background-color: ${s.bgColor} !important;
        }
        .splide__arrow svg {
            fill: ${s.actionColor} !important;
        }
        .splide__video__play:after {
            border-color: transparent transparent transparent ${s.actionColor} !important;
        }
        .my-carousel-progress-bar {
            background: ${s.actionColor} !important;
        }
        .splide__pagination__page.is-active {
            background-color: ${s.actionColor} !important;
        }
        .splide__pagination__page {
            background-color: ${s.bgColor} !important;
        }
        `
    return style;
}
const waterMark = () => {
    let a = document.createElement('a');
    a.setAttribute('target', "_blank");
    a.setAttribute('href', "https://vanyadoing-dev.com");
    a.setAttribute('style', "position:absolute; bottom: 0; place-self: center;display: inherit;display: flex;width: 100%;justify-content: center;");
    a.innerHTML =
        `
    <svg version="1.1" style="width: 140px;max-width: 100%;height: auto;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="740.7px" height="56.5px" viewBox="0 0 740.7 56.5" style="enable-background:new 0 0 740.7 56.5;" xml:space="preserve">
    <style type="text/css">
    	.st0{fill:#FF0000;}
    	.st1{fill:#FFFFFF;}
    </style>
    <path class="st0" d="M740.7,56.5H0c0,0,0-12.6,0-28.2v0C0,12.6,13.5,0,30.2,0h680.4c16.7,0,30.2,12.6,30.2,28.2v0
    	C740.7,43.8,740.7,56.5,740.7,56.5z"/>
    <g>
	<path class="st1" d="M127,12.5h9v24.1l9.8,9.8h29.8V12.5h9v43h-42.5L127,40.4V12.5z M238.3,29.5v-7.9h-39.6v7.9H238.3z M247.3,55.5
		h-9V38.6h-39.6v16.9h-9.1v-43h57.6L247.3,55.5L247.3,55.5z M300.9,12.5h9.1v43h-13.7l-34.9-34.9v34.9h-9v-43h13.7l34.8,34.9V12.5
		L300.9,12.5z M363.7,12.5h9v27.8l-15.1,15.2H315v-9.1h38.8l7.9-7.9H341l-26-26h12.8l17,17h18.9V12.5z M426.4,29.5v-7.9h-39.6v7.9
		H426.4L426.4,29.5z M435.4,55.5h-9V38.6h-39.6v16.9h-9.1v-43h57.6v43H435.4z"/>
	<path class="st1" d="M451.6,21.6v24.8h29.8l9.8-9.8v-15H451.6z M500.2,12.5v27.8l-15.1,15.2h-42.5v-43H500.2z M514.2,21.6v24.8
		h39.6V21.6H514.2z M505.2,12.5h57.6v43h-57.6V12.5L505.2,12.5z M567.9,12.5h9.1v43h-9.1V12.5z M630.6,12.5h9.1v43H626l-34.9-34.9
		v34.9h-9v-43h13.7l34.8,34.9V12.5z M644.7,12.5h57.6v9.1h-48.6v24.8h39.6v-7.9h-19.8v-9h28.8v26h-57.6
		C644.7,55.5,644.7,12.5,644.7,12.5z"/>
	<g>
		<path class="st1" d="M73.7,31.6l-6.8,7.3l6.8,7.3v7.5H36.8V24.1h36.9V31.6z M66.7,30.3H42.6v5.4h19.1L66.7,30.3z M42.6,42.1v5.4
			h24.1l-5-5.4H42.6z"/>
		<path class="st1" d="M113.8,24.1v19.3l-9.6,10.5H76.9v-6.3h24.8l5.1-5.4H93.6l-16.6-18h8.2l10.8,11.7H108V24.1H113.8z"/>
	</g>
    </g>
    `
    return a;
}
// const childHTML = (props) => {
//     let list = document.createElement("ul");
//     list.classList.add("splide__list");

//     let innerHTML_string = '';
//     let playlist = props.playerProps.listType === 'playlist' ? "&list=" + props.playerProps.list : '';

//     // Function to get correct thumbnail
//     function getThumbnail(youtube_video_id) {
//         return new Promise((resolve) => {
//             const testImg = new Image();
//             testImg.onload = () => {
//                 // Check dimensions for fallback
//                 if (testImg.width <= 120 && testImg.height <= 90) {
//                     // If small, fallback to hqdefault
//                     resolve(`//img.youtube.com/vi/${youtube_video_id}/hqdefault.jpg`);
//                 } else {
//                     // Otherwise, maxresdefault works fine
//                     resolve(`//img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg`);
//                 }
//             };
//             testImg.onerror = () => {
//                 // If there's an error loading the image,
//                 // fallback to hqdefault
//                 resolve(`//img.youtube.com/vi/${youtube_video_id}/hqdefault.jpg`);
//             };
//             testImg.src = `//img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg`;
//         });
//     }

//     // Now loop through each video ID, but we wait for thumbnail resolution
//     Promise.all(props.data.map((youtube_video_id) => getThumbnail(youtube_video_id)))
//         .then((thumbnails) => {
//             thumbnails.forEach((thumb, index) => {
//                 const youtube_video_id = props.data[index];
//                 let width = '';
//                 let attribute = '';
//                 if (props.sliderProps.responsiveBehavior === "item") {
//                     width = `width: ${props.sliderProps.itemWidth}px;`;
//                 }
//                 if (props.sliderProps.moveMode === "autoplay") {
//                     attribute = `data-splide-interval="${props.sliderProps.interval}"`;
//                 }

//                 innerHTML_string += `
//                     <li class="splide__slide review-item" 
//                         data-splide-youtube="https://www.youtube.com/watch?v=${youtube_video_id}${playlist}" 
//                         ${attribute} style="${width}">
//                         <img src="${thumb}">
//                         ${props.wm ? waterMark() : ''}
//                     </li>
//                 `;
//             });

//         });
//     list.innerHTML = innerHTML_string;
//     return list;
// };
const childHTML = (props) => {
    let list = document.createElement("ul");
    list.classList.add("splide__list");
    let playlist = props.playerProps.listType === 'playlist' ? "&list=" + props.playerProps.list : '';

    for (let i = 0; i < props.data.length; i++) {
        const youtube_video_id = props.data[i];

        // Create the list item
        const li = document.createElement('li');
        li.classList.add("splide__slide", "review-item");
        li.setAttribute("data-splide-youtube", `https://www.youtube.com/watch?v=${youtube_video_id}${playlist}`);

        if (props.sliderProps.moveMode === "autoplay") {
            li.setAttribute('data-splide-interval', props.sliderProps.interval);
        }
        if (props.sliderProps.responsiveBehavior === "item") {
            li.style.width = `${props.sliderProps.itemWidth}px`;
        }

        const img = document.createElement('img');
        img.setAttribute('data-video-url', youtube_video_id);
        img.onload = function () {
            const videoURL = this.getAttribute('data-video-url');
            if (this.naturalWidth <= 120 && this.naturalHeight <= 90) {
                this.src = `//img.youtube.com/vi/${videoURL}/hqdefault.jpg`;
                const allMatchingImages = list.querySelectorAll(`img[data-video-url="${videoURL}"]`);
                allMatchingImages.forEach(el => {
                    el.src = `//img.youtube.com/vi/${videoURL}/hqdefault.jpg`;
                });
            }
        };
        img.src = `//img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg`;

        // Create an Image object but don't append it immediately
        // const testImg = new Image();
        // testImg.oncopy = (e) => {
        //     console.log("copy")
        // }
        // testImg.onloadeddata = (e) => {
        //     console.log("onloadeddata")
        // }
        // testImg.setAttribute('onload(e)','console.log("e")')
        // testImg.onload = (e) => {
        //     console.log(e);
        //     console.log(testImg);
        //     // Check dimensions for fallback
        // if (testImg.naturalWidth <= 120 && testImg.naturalHeight <= 90) {
        //     testImg.src = `//img.youtube.com/vi/${youtube_video_id}/hqdefault.jpg`;
        // }
        //     // Now we have the correct src. Append watermark if needed:
        //     // if (props.watermark) {
        //     //     li.appendChild(waterMark());
        //     // }
        //     //li.appendChild(testImg);
        // };
        // testImg.onerror = () => {
        //     // If there's an error loading the image, fallback to hqdefault
        //     testImg.src = `//img.youtube.com/vi/${youtube_video_id}/hqdefault.jpg`;

        // };

        // Start loading maxresdefault to determine availability
        //img.src = `//img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg`;

        li.appendChild(img);
        if (props.wm) {
            li.appendChild(waterMark());
        }
        // Append the li once the image is set (done in onload above)
        list.appendChild(li);
    }

    return list;
};
// const childHTML = (props) => {
//     let list = document.createElement("ul");
//     list.setAttribute('class', "splide__list");
//     let innerHTML_string = '';
//     let playlist = props.playerProps.listType === 'playlist' ? "&list=" + props.playerProps.list : '';
//     props.data.forEach((youtube_video_id, index) => {
//         fetch(https://img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg,{"mode":"no-cors"}).then(()=>{
//         let width = '';
//         let attribute = '';
//         if (props.sliderProps.responsiveBehavior === "item") {
//             width = width: ${props.sliderProps.itemWidth}px;;
//         }
//         if (props.sliderProps.moveMode === "autoplay") {
//             attribute = data-splide-interval="${props.sliderProps.interval}";
//         }
//         innerHTML_string += 
// 			<li class="splide__slide review-item" data-splide-youtube="https://www.youtube.com/watch?v=${youtube_video_id}${playlist}" ${attribute} style="${width}">
//                 <img src="//img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg">
//                 ${props.wm?waterMark():''}
// 			</li>

//         }).catch((err)=>{
//         let width = '';
//         let attribute = '';
//         if (props.sliderProps.responsiveBehavior === "item") {
//             width = width: ${props.sliderProps.itemWidth}px;;
//         }
//         if (props.sliderProps.moveMode === "autoplay") {
//             attribute = data-splide-interval="${props.sliderProps.interval}";
//         }
//         innerHTML_string += 
// 			<li class="splide__slide review-item" data-splide-youtube="https://www.youtube.com/watch?v=${youtube_video_id}${playlist}" ${attribute} style="${width}">
//                 <img src="//img.youtube.com/vi/${youtube_video_id}/hqdefault.jpg">
//                 ${props.wm?waterMark():''}
// 			</li>

//         })

//         //<img src="preview01.jpg">
//         // innerHTML_string += 
//         // 	<li class="splide__slide review-item" ${attribute} style="${width}">
//         //         <div id="id-${item}"></div>
//         // 	</li>
//         //     
//     })
//     list.innerHTML = innerHTML_string;

//     return list;
// }

// const childHTML = (props) => {
//     let list = document.createElement("ul");
//     list.classList.add("splide__list");
//     let playlist = props.playerProps.listType === 'playlist' ? "&list=" + props.playerProps.list : '';
//     for (let i = 0; i < props.data.length; i++) {
//         const youtube_video_id = props.data[i];

//         let li = document.createElement('li');
//         li.classList.add("splide__slide review-item");
//         li.setAttribute("data-splide-youtube",`https://www.youtube.com/watch?v=${youtube_video_id}${playlist}`);
//         if (props.sliderProps.moveMode === "autoplay") {
//             li.setAttribute('data-splide-interval',props.sliderProps.interval);
//         }
//         if (props.sliderProps.responsiveBehavior === "item") {
//             li.setAttribute('style',`width: ${props.sliderProps.itemWidth}px;`);
//         }
//         const testImg = new Image();
//         testImg.onload = () => {
//                 // Check dimensions for fallback
//                 if (testImg.width <= 120 && testImg.height <= 90) {
//                     // If small, fallback to hqdefault
//                    testImg.src = `//img.youtube.com/vi/${youtube_video_id}/hqdefault.jpg`;
//                 } else {
//                     // Otherwise, maxresdefault works fine
//                     testImg.src = `//img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg`;
//                 }
//             };
//         testImg.onerror = () => {
//                 // If there's an error loading the image,
//                 // fallback to hqdefault
//                 testImg.src = `//img.youtube.com/vi/${youtube_video_id}/hqdefault.jpg`;
//         };
//         testImg.src = `//img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg`;
//         if(props.watermark){
//             li.appendChild(waterMark());
//         }
//         li.appendChild(testImg);
//         list.appendChild(li);
//     }

//     // props.data.forEach((youtube_video_id, index) => {
//     //     fetch(`https://img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg`,{"mode":"no-cors"}).then(()=>{
//     //     let width = '';
//     //     let attribute = '';
//     //     if (props.sliderProps.responsiveBehavior === "item") {
//     //         width = `width: ${props.sliderProps.itemWidth}px;`;
//     //     }
//     //     if (props.sliderProps.moveMode === "autoplay") {
//     //         attribute = `data-splide-interval="${props.sliderProps.interval}"`;
//     //     }
//     //     innerHTML_string += `
// 	// 		<li class="splide__slide review-item" data-splide-youtube="https://www.youtube.com/watch?v=${youtube_video_id}${playlist}" ${attribute} style="${width}">
//     //             <img src="//img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg">
//     //             ${props.wm?waterMark():''}
// 	// 		</li>
//     //         `            
//     //     }).catch((err)=>{
//     //     let width = '';
//     //     let attribute = '';
//     //     if (props.sliderProps.responsiveBehavior === "item") {
//     //         width = `width: ${props.sliderProps.itemWidth}px;`;
//     //     }
//     //     if (props.sliderProps.moveMode === "autoplay") {
//     //         attribute = `data-splide-interval="${props.sliderProps.interval}"`;
//     //     }
//     //     innerHTML_string += `
// 	// 		<li class="splide__slide review-item" data-splide-youtube="https://www.youtube.com/watch?v=${youtube_video_id}${playlist}" ${attribute} style="${width}">
//     //             <img src="//img.youtube.com/vi/${youtube_video_id}/hqdefault.jpg">
//     //             ${props.wm?waterMark():''}
// 	// 		</li>
//     //         `
//     //     })
//     //     //<img src="preview01.jpg">
//     //     // innerHTML_string += `
//     //     // 	<li class="splide__slide review-item" ${attribute} style="${width}">
//     //     //         <div id="id-${item}"></div>
//     //     // 	</li>
//     //     //     `
//     // })
//     // list.innerHTML = innerHTML_string;

//     return list;
// }
const parentHTML = (props) => {
    let section = document.createElement("section");
    section.id = props.splideID;
    section.setAttribute('class', "splide");
    section.setAttribute('aria-label', "Youtube Gallery");
    let track = document.createElement("div");
    track.setAttribute('class', "splide__track");
    track.appendChild(childHTML(props));
    section.appendChild(track);
    if (props.sliderProps.pagination === "progress") {
        let progressBar = document.createElement("div");
        progressBar.setAttribute('class', "my-carousel-progress");
        progressBar.innerHTML = `<div class="my-carousel-progress-bar"></div>`;
        section.appendChild(progressBar);
    }

    return section;
}

export function assemble(props) {
    return {
        css: mainStyle(props),
        html: parentHTML(props)
    }
}